import React from 'react'
import styled from '@emotion/styled'
import { PortalRichText, PortalRichTextPart } from '../../../models/PortalArtigoModel'
import { portalEditorColors } from './PortalEditorTheme'

interface PortalRichTextPreviewProps {
  value?: PortalRichText
  compact?: boolean
}

export function PortalRichTextPreview({ value, compact = true }: PortalRichTextPreviewProps) {
  const parts = toParts(value)

  if (isEmptyRichText(parts)) {
    return <EmptyText>Sem texto</EmptyText>
  }

  return (
    <PreviewText className={compact ? 'is-compact' : undefined}>
      {parts.map((part, index) => renderPart(part, index))}
    </PreviewText>
  )
}

function renderPart(part: PortalRichTextPart, index: number) {
  if (typeof part === 'string') {
    return <React.Fragment key={index}>{part}</React.Fragment>
  }

  if (part.type === 'link') {
    return (
      <LinkPreview
        key={index}
        type="button"
        onClick={(event) => event.preventDefault()}
      >
        {part.text || part.href || 'Link sem texto'}
      </LinkPreview>
    )
  }

  return <strong key={index}>{part.text}</strong>
}

function toParts(value?: PortalRichText) {
  if (!value) return []
  return Array.isArray(value) ? value : [value]
}

function isEmptyRichText(parts: PortalRichTextPart[]) {
  return parts.every((part) => {
    if (typeof part === 'string') return part.trim().length === 0
    return !part.text?.trim()
  })
}

const PreviewText = styled.div`
  width: 100%;
  color: #262626;
  line-height: 1.45;
  white-space: pre-wrap;
  overflow-wrap: anywhere;

  &.is-compact {
    display: -webkit-box;
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
  }
`

const EmptyText = styled.div`
  color: #8c8c8c;
  font-style: italic;
`

const LinkPreview = styled.button`
  border: 0;
  padding: 0;
  margin: 0;
  background: transparent;
  color: ${portalEditorColors.orange};
  text-decoration: underline;
  cursor: default;
  font: inherit;
`
